import AboutMe from "../../Components/AboutMe/AboutMe";
import Blog from "../../Components/Blog/Blog";
import Expriences from "../../Components/Expriences/Expriences";
import Feedback from "../../Components/Feedback/Feedback";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import Nav from "../../Components/Nav/Nav"
import Projects from "../../Components/Projects/Projects";
import Services from "../../Components/Services/Services";
import Skills from "../../Components/Skills/Skills";

export default function LandingPage (){
    return (
        <div className="landingpage">  
            <div className="blur-light"></div>
            <Nav />
            <Header/>
            <AboutMe />
            <Expriences />
            <Projects />
            <Services />
            <Skills />
            <Blog />
            <Feedback />
            <Footer />
        </div>
    )
}